import React, { useEffect, useState } from "react";
import Layout from "../shared/Layout";
import { Toaster } from "react-hot-toast";
import { GetImage, ImportTemplate, UploadProductImages } from "../../_services";
import toast from "react-hot-toast";
import { baseurl, imageurl, projectNo } from "../../_config";
import { resizeImage } from "../../_services/resizeImage";

const BulkProductImageUpload = () => {
    const [productImages, setProductImages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [imagesPerPage] = useState(12);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        files: [],
    });

    const handleFileChange = async (e) => {
        const files = e.target.files;

        // Check the file type and resize if it's an image (JPEG/PNG)
        if (files && files.length > 0) {
            for (let file of files) {
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    const image = new Image();
                    image.src = URL.createObjectURL(file);

                    image.onload = async () => {
                        const { width, height } = image;

                        try {
                            // Resize the image if necessary
                            const resizedFile = await resizeImage(file);

                            // Add resized file to formData
                            setFormData((prevState) => ({
                                ...prevState,
                                files: [...prevState.files, resizedFile], // Add to the files array
                            }));

                        } catch (err) {
                            toast.error("Error resizing the image.");
                        }
                    };
                } else {
                    toast.error("Only JPEG and PNG images are allowed.");
                }
            }
        }
    };

    const onBulkUpload = async (e) => {
        e.preventDefault();

        if (formData.files.length === 0) {
            toast.error("Please select at least one file to upload.");
            return;
        }

        const uploadData = new FormData();
        formData.files.forEach((file) => {
            uploadData.append("files", file);
        });

        try {
            const response = await UploadProductImages(uploadData);

            if (response?.isSuccess) {
                toast.success("Images uploaded successfully.");
                fetchImages();

                setFormData({ files: [] });
                document.getElementById("file").value = "";
            }
        } catch (error) {
            toast.error("Failed to upload images. Please try again.");
        }
    };

    const fetchImages = async () => {
        try {
            const data = await GetImage();
            if (data.isSuccess === 200) {
                setProductImages(data.data);
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        }
    };

    const indexOfLastImage = currentPage * imagesPerPage;
    const indexOfFirstImage = indexOfLastImage - imagesPerPage;
    const currentImages = productImages.slice(indexOfFirstImage, indexOfLastImage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        fetchImages();
    }, []);

    const totalPages = Math.ceil(productImages.length / imagesPerPage);

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="admin-page px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Bulk Product Image Upload</h4>
                    </div>
                </div>
                <div className="datatable mt-3">
                    <form onSubmit={onBulkUpload}>
                        <div className="form-group">
                            <label htmlFor="file" className="mb-1">Upload Images{projectNo === 'GAILEE' && (`(640*960)`) }</label>
                            <input
                                type="file"
                                className="form-control"
                                id="file"
                                name="file"
                                multiple // Allow multiple files
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className="upload_btn mt-2">
                            <button type="submit" className="">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
                {/* <div className="image-gallery mt-4">
                    <h5 className="mb-2">Uploaded Product Images</h5>
                    <div className="row">
                        {productImages.length > 0 ? (
                            productImages.map((image, index) => (
                                <div key={index} className="col-lg-2 col-md-3 col-sm-4 col-6 img_fluid_wrapper mb-2">
                                    <img
                                        src={`${imageurl}/images/ProductImage/${image}` || ""}
                                        alt={`product-image-${index}`}
                                        width="100"
                                        className=""
                                    />
                                    <p className="image_name">{image}</p>
                                </div>
                            ))
                        ) : (
                            <p>No images found.</p>
                        )}
                    </div> */}
                {/* </div> */}
                <div className="image-gallery mt-4">
                    <h5 className="mb-2">Uploaded Product Images</h5>
                    <div className="row">
                        {currentImages.length > 0 ? (
                            currentImages.map((image, index) => (
                                <div key={index} className="col-lg-2 col-md-3 col-sm-4 col-6 img_fluid_wrapper mb-2">
                                    <img
                                        src={`${imageurl}/images/ProductImage/${image}` || ""}
                                        alt={`product-image-${index}`}
                                        width="100"
                                        className=""
                                    />
                                    <p className="image_name">{image}</p>
                                </div>
                            ))
                        ) : (
                            <p>No images found.</p>
                        )}
                    </div>

                    <div className="pagination mt-3">
                        <button
                            onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                            disabled={currentPage === 1}
                            className="pagination_button mr-2"
                        >
                            Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => paginate(index + 1)}
                                className={`btn btn-sm ${currentPage === index + 1 ? "pagination_button_active" : "pagination_button_dactive btn-outline-primary"} mr-2`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button 
                            onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination_button btn-sm ml-2"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default BulkProductImageUpload;
